import { render, staticRenderFns } from "./back-money-student-info.pug?vue&type=template&id=7aa75e10&lang=pug&"
import script from "./back-money-student-info.ts?vue&type=script&lang=ts&"
export * from "./back-money-student-info.ts?vue&type=script&lang=ts&"
import style0 from "./back-money-student-info.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports